import { apiInterceptor } from 'utils/apiInterceptor';
import { isAuthenticated } from 'utils/auth';
let headers = null;
/**
 * Get bookmarks
 */
export async function getBookmarks(projectId, type, limit = 10, page = 1) {
    let endpoint = `${process.env.REACT_APP_MYXP_API}/manager/livestream/analytics/bookmarks?type=${type}&projectId=${projectId}&limit=${limit}&page=${page}`;

    if (isAuthenticated()) {
        const response = await apiInterceptor(endpoint, {
            method: 'GET',
            headers,
        });

        return await response.json();
    }
}
export async function exportBookmarks(projectId, type) {
    let endpoint = `${process.env.REACT_APP_MYXP_API}/manager/livestream/analytics/bookmarks/export?type=${type}&projectId=${projectId}`;

    if (isAuthenticated()) {
        const response = await apiInterceptor(endpoint, {
            method: 'GET',
            headers,
        });

        return await response.blob();
    }
}
